import type Encounter from "@/encounter/model/Encounter.ts";

export function encounterCardImage(encounter: Encounter) {
    return encounter.coverImage ?? encounter.dungeonImage;
}
